<template>
  <div>

      <div class="text-h6 text-left">Stats</div>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" xl="2" lg="4" md="12"  v-for="stat in stats" :key="stat.name">
          <StatCard :stat-name="stat.name" :state-value="stat.value"/>
        </v-col>
      </v-row>
  </div>

</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const StatsRepo = RepositoryFactory.get('stats')
import StatCard from "@/components/common/StatCard";
export default {
name: "SubredditInfo",
  components: {StatCard},
  data: () => ({
    subredditData: null,
    subredditStats: null,
    loading: true,
    stats: [
      {
        name: 'Checked Posts - All',
        statKey: 'checked_post_all',
        value: null
      },
      {
        name: 'Checked Posts - Month',
        statKey: 'checked_post_month',
        value: null
      },
      {
        name: 'Checked Posts - Day',
        statKey: 'checked_post_day',
        value: null
      },
      {
        name: 'Image Reposts - All',
        statKey: 'image_reposts_all',
        value: null
      },
      {
        name: 'Image Reposts - Month',
        statKey: 'image_reposts_month',
        value: null
      },
      {
        name: 'Image Reposts - Day',
        statKey: 'image_reposts_day',
        value: null
      },
      {
        name: 'Link Reposts - All',
        statKey: 'link_reposts_all',
        value: null
      },
      {
        name: 'Link Reposts - Month',
        statKey: 'link_reposts_month',
        value: null
      },
      {
        name: 'Link Reposts - Day',
        statKey: 'link_reposts_day',
        value: null
      },
      {
        name: 'Summons - All',
        statKey: 'summons_all',
        value: null
      },
      {
        name: 'Summons - Month',
        statKey: 'summons_month',
        value: null
      },
      {
        name: 'Summons - Day',
        statKey: 'summons_day',
        value: null
      },
    ]
  }),
  props: {
    subredditName: String
  },
  methods: {
    fetchStat(statKey) {
      return StatsRepo.getSubredditStats({'params': {stat_name: statKey}}, this.subredditName)
    }
  },
  mounted() {
    this.stats.forEach(stat => {
      this.fetchStat(stat.statKey)
          .then(res => {
            console.log(res)
            let index = this.stats.findIndex(x => x.statKey === stat.statKey)
            this.stats[index].value = res.data.count
          })
    })
  }
}
</script>

<style scoped>

</style>
